import DtcMappingErrors from '../../../components/vehicle/dtc_mapping_errors'
import DtcMappingErrorsStore from '../../../components/vehicle/dtc_mapping_errors/context/context'

const DtcMappingErrorsPage = () => {
  return (
    <DtcMappingErrorsStore>
      <DtcMappingErrors />
    </DtcMappingErrorsStore>
  )
}

export default DtcMappingErrorsPage
